// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "controlbutton_button__b51vl";
var _3 = "controlbutton_buttoncontent__ek5gw";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "controlbutton_disabled__efs93";
var _8 = "#434343";
var _9 = "79px";
var _a = "110px";
var _b = "72px";
var _c = "665px";
var _d = "controlbutton_overlay__vtfwx";
var _e = "controlbutton_small__xdsas";
var _f = "teal";
var _10 = "2";
var _11 = "#cdd3dc";
export { _1 as "body", _2 as "button", _3 as "buttonContent", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "disabled", _8 as "headline", _9 as "menuHeight", _a as "menuHeightLarge", _b as "menuHeightMobile", _c as "modalMobileWidth", _d as "overlay", _e as "small", _f as "teal", _10 as "timelineStrokeWidth", _11 as "timelineTrackColor" }
